import { render, staticRenderFns } from "./ModalUpdateAgent.vue?vue&type=template&id=b8ff21dc&"
import script from "./ModalUpdateAgent.vue?vue&type=script&lang=ts&"
export * from "./ModalUpdateAgent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports